import { Component, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { fabric } from 'fabric';
import { AppSettings } from 'src/app/app-settings';
import { AreasSeatService } from 'src/app/services/areas-seat.service';
import { GenerateMapService } from 'src/app/services/generate-map.service';

@Component({
  selector: 'app-edit-section',
  templateUrl: './edit-section.component.html',
  styleUrls: ['./edit-section.component.scss']
})
export class EditSectionComponent implements OnInit, OnChanges, DoCheck, OnDestroy {

  @Input() sectionElement!: any;
  @Input() colorDefaultSeat!: any;
  @Input() canvas!: any;
  @Input() cancel!: any;

  isEditing: boolean = false;

  sectionObj!: any;
  sectionSeats!: any;
  visibilityNameSection: boolean = true;
  visibilityNameRows: boolean = true;
  invisibleSeats: any[] = [];

  valueName!: string;
  valueTilt: number = 0;
  valueAngle: number = 0;
  sectionNumber!: number;
  areaNumber!: number;
  level!: any;

  @Output() updateCanvas = new EventEmitter<any>();
  @Output() activeEdit = new EventEmitter<any>();
  @Output() closeTab = new EventEmitter<any>();
  @Output() setHiddenSectionMode = new EventEmitter<boolean>();
  @Output() setSpecialSeatMode = new EventEmitter<{ active: boolean; level?: any }>();
  // Pide al padre que reconstruya en el canvas la sección tras cambiar filas/columnas.
  @Output() rebuildSection = new EventEmitter<any>();
  // Pide reconstruir la sección radial indicada (al mover su centro de curvatura propio),
  // manteniendo el marcador de centro activo.
  @Output() rebuildRadialSections = new EventEmitter<any>();

  activedEditing: boolean = false;
  firstTime: boolean = false;

  // Edit seat
  @Input() sitSelect!: any;
  @Input() seatsEditSelected!: any;
  @Input() openSeatEditing: boolean = false;
  @Input() levels!: any[];

  @Output() editSeatParams = new EventEmitter<any>();

  visibilitySeat: boolean = false;
  valueSeat!: any;
  valueRow!: any;

  legendLeft: boolean = true;
  legendRight: boolean = true;
  startRow: number = 1;
  startSeat: number = 1;

  // ==== Butaca de inicio por fila (override sobre la numeración global de la sección) ====
  rowLabels: number[] = [];
  selectedRowForStart: number | null = null;
  rowStartSeatValue: number | null = null;
  rowStartSeatOverrides: { [row: number]: number } = {};

  numeracionImpar: boolean = false;
  numeracionPar: boolean = false;

  // ==== Qué parte de la posición se le enseña al comprador ====
  // La parrilla de filas × columnas es a veces solo la forma de dibujar el plano y no
  // información útil: un recinto donde se venden mesas se monta como dos filas (una a
  // cada lado de la calle) y el número de butaca ES el de la mesa, así que la entrada
  // tiene que decir «Mesa 12» y no «Mesa, Fila: 1, Butaca: 12».
  // Solo afectan a lo que se PINTA: row y seat se siguen guardando igual, porque
  // posicionan la butaca y forman parte de su identidad.
  showRowOnTicket: boolean = true;
  showSeatLabelOnTicket: boolean = true;

  directionRight: boolean = true;
  // Invierte la numeración de filas: en vez de 1..X (arriba→abajo), las etiqueta X..1.
  // Solo relabela (espejo min+max−row); las posiciones físicas no se mueven.
  reverseRows: boolean = false;
  // Tamaño editable de la parrilla (filas × columnas) de una sección ya creada.
  numRows: number = 0;
  numCols: number = 0;
  mostrarOcultos: boolean = false;
  numberAngle: number = 0;
  seatNumberAngle: number = 0;
  valueCurvature: number = 0;
  columnSpacing: number = 1.2;
  rowSpacing: number = 1.2;
  seatColor: string = '#ffffff';

  // Personalización por fila (solo modo de curvatura 'parabolic'). Filas sin override usan el
  // espaciado global (rowSpacing/columnSpacing) como hasta ahora.
  rowSpacingPerRow: boolean = false;
  // Espacio vertical respecto a la fila ANTERIOR (no aplica a la posición 1: no tiene fila
  // anterior). Indexado por posición física 1-based.
  rowSpacingOverrides: Record<number, number> = {};
  // Espacio horizontal entre butacas DENTRO de esa misma fila. Aplica a cualquier posición.
  columnSpacingOverrides: Record<number, number> = {};
  // Desplazamiento horizontal manual de la fila entera (leyendas incluidas), para recolocarla
  // tras cambiar su espacio entre butacas (que la ensancha siempre desde el mismo lado). Aplica
  // a cualquier posición; 0 = sin desplazar (comportamiento de hoy).
  rowOffsetXOverrides: Record<number, number> = {};
  // Posición física 1-based de cada fila, en orden top-to-bottom.
  rowsForSpacing: { position: number; label: number }[] = [];
  selectedRowSpacingPosition: number | null = null;
  selectedRowSpacingValue: number | null = null;
  selectedColumnSpacingValue: number | null = null;
  selectedRowOffsetXValue: number | null = null;

  // ==== Curvatura radial/elíptica (arcos concéntricos alrededor de un centro propio de la sección) ====
  // 'parabolic' = comportamiento clásico por sección (por defecto). 'radial' = arcos concéntricos
  // (círculo perfecto) alrededor de un centro externo. 'elliptical' = igual que radial pero
  // permitiendo achatar (ellipseAspect) y rotar (ellipseRotation) el óvalo.
  curvatureMode: 'parabolic' | 'radial' | 'elliptical' = 'parabolic';
  // Centro de curvatura C en coords de canvas; propio de esta sección (cada sección radial
  // guarda el suyo en su seatsGroupConfig).
  curvatureCenter: { x: number, y: number } | null = null;
  // Radio (unidades canvas) de la fila central; null => se deriva/congela en el primer render.
  baseRadius: number | null = null;
  // Invierte qué fila queda más cerca del centro.
  radialInvert: boolean = false;
  // Proporción eje Y / eje X del arco (1 = círculo, <1 = óvalo achatado).
  ellipseAspect: number = 1;
  // Rotación del eje mayor del óvalo, en grados (0 = sin rotar).
  ellipseRotation: number = 0;
  // Marcador arrastrable del centro de curvatura sobre el lienzo.
  showCurvatureCenter: boolean = false;
  private curvatureMarker: any = null;
  private curvatureMovingHandler: any = null;
  private curvatureUpHandler: any = null;
  // Coloca el centro donde el usuario haga clic en el mapa (además de poder arrastrar el marcador).
  private curvaturePlaceHandler: any = null;

  // colorDefaultSeat = this.areaService.colorDefaultSeat;
  // colorDefaultDisplay = this.areaService.colorDefaultDisplay;
  colorDefaultVisibility = this.areaSeat.colorDefaultVisibility;

  activeResize: boolean = false;
  activeEditingSeats: boolean = false;
  activeEditingRows: boolean = false;
  activeHiddenSeats: boolean = false;
  selectingInvisibleMode: boolean = false;

  activeSpecialSeats: boolean = false;
  selectingSpecialMode: boolean = false;
  specialSeatLevel: any = null;

  constructor(private areaSeat: AreasSeatService, private generateMapService: GenerateMapService) { }

  ngOnInit(): void {
    if (this.sectionElement) {
      this.getValuesObjects();
      this.activeEditing();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Tras reconstruir la sección (cambio de filas/columnas), el padre reasigna el grupo:
    // resincronizar el panel con el nuevo grupo sin recrear el componente.
    if (changes['sectionElement'] && !changes['sectionElement'].firstChange && this.sectionElement) {
      this.getValuesObjects();
    }
  }

  ngDoCheck(): void {
    if (this.sectionElement && this.sectionElement._lastCanvasAngle != null) {
      this.valueAngle = this.sectionElement._lastCanvasAngle;
      delete this.sectionElement._lastCanvasAngle;
    }
  }

  getValuesObjects() {
    // Nombre seccion
    this.sectionObj = this.sectionElement._objects[0];
    this.valueName = this.sectionObj.text;
    this.visibilityNameSection = this.sectionObj.visible;

    // Asientos
    this.sectionSeats = this.sectionElement._objects[1];
    this.legendLeft = this.sectionSeats.rowsLegendLeft;
    this.legendRight = this.sectionSeats.rowsLegendRight;
    this.visibilityNameRows = !this.sectionSeats.showRows;
    this.sectionNumber = this.sectionSeats.section.id;

    // Ángulo: usar la configuración guardada como fuente de verdad (evita que al duplicar
    // el fabric object tenga angle=0 mientras el panel muestra 0 aunque la sección esté rotada)
    const storedSections = this.generateMapService.getSeatSections();
    const storedAngle = storedSections?.[this.sectionNumber]?.section?.configuration?.angle;
    this.valueAngle = storedAngle != null ? storedAngle : (this.sectionElement.angle ?? 0);
    this.visibilityNameRows = this.sectionSeats._objects[0].visible || this.sectionSeats._objects[this.sectionSeats._objects.length - 1].visible;

    // Ángulo de números de fila
    this.numberAngle = this.sectionSeats.numberAngle || 0;
    this.seatNumberAngle = this.sectionSeats.seatNumberAngle || 0;
    this.valueCurvature = this.sectionSeats.curvature || 0;
    this.columnSpacing = this.sectionSeats.columnSpacing || 1.2;
    this.rowSpacing = this.sectionSeats.rowSpacing || 1.2;

    // Estado de curvatura radial/elíptica (desde la config guardada; retrocompatible => 'parabolic').
    const sgc = storedSections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig || {};
    this.curvatureMode = (sgc.curvatureMode === 'radial' || sgc.curvatureMode === 'elliptical') ? sgc.curvatureMode : 'parabolic';
    this.curvatureCenter = sgc.curvatureCenter ? { x: sgc.curvatureCenter.x, y: sgc.curvatureCenter.y } : this.curvatureCenter;
    this.baseRadius = sgc.baseRadius != null ? +sgc.baseRadius : null;
    this.radialInvert = !!sgc.radialInvert;
    this.ellipseAspect = sgc.ellipseAspect != null ? +sgc.ellipseAspect : 1;
    this.ellipseRotation = sgc.ellipseRotation != null ? +sgc.ellipseRotation : 0;

    // Ausente => true: los mapas publicados antes de que existieran estos flags siguen
    // enseñando fila y butaca como siempre.
    this.showRowOnTicket = sgc.showRowOnTicket !== false;
    this.showSeatLabelOnTicket = sgc.showSeatLabelOnTicket !== false;

    // Estado del orden invertido de filas (solo para reflejar el checkbox; los números ya
    // vienen relabelados en los asientos guardados).
    this.reverseRows = !!(this.sectionSeats.reverseRows
      ?? storedSections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig?.reverseRows);

    // Tamaño actual de la parrilla
    this.numRows = +this.sectionSeats.rows || +storedSections?.[this.sectionNumber]?.section?.rows || 1;
    this.numCols = +this.sectionSeats.columns || +storedSections?.[this.sectionNumber]?.section?.columns || 1;

    // Personalización por fila: releer estado guardado y reconstruir la lista de filas
    // (posición física + etiqueta visible) a partir de `elements`, que conserva el orden
    // top-to-bottom en bloques de `numCols` (mismo criterio que generate-map.service.addGroupSeats).
    this.rowSpacingPerRow = !!sgc.rowSpacingPerRowEnabled;
    this.rowSpacingOverrides = sgc.rowSpacingOverrides || {};
    this.columnSpacingOverrides = sgc.columnSpacingOverrides || {};
    this.rowOffsetXOverrides = sgc.rowOffsetXOverrides || {};
    const elementsForRows: any[] = storedSections?.[this.sectionNumber]?.elements || [];
    this.rowsForSpacing = [];
    for (let numF = 0; numF < this.numRows; numF++) {
      const label = elementsForRows[numF * this.numCols]?.row;
      this.rowsForSpacing.push({ position: numF + 1, label: label != null ? +label : numF + 1 });
    }
    if (this.selectedRowSpacingPosition == null || !this.rowsForSpacing.some(r => r.position === this.selectedRowSpacingPosition)) {
      this.selectedRowSpacingPosition = this.rowsForSpacing.length ? this.defaultRowSpacingPosition() : null;
    }
    this.onSelectRowForSpacing();

    // Cargar asientos ya ocultos (isVisible===false indica seat oculto, independientemente de eventSeat que se pone a false en contexto de evento)
    this.invisibleSeats = this.sectionSeats._objects.filter(s => s.isVisible === false && !s.numberLeft && !s.numberRight);

    // Fila de inicio: el menor número de fila (independiente del orden físico/invertido)
    const rowSeats = this.sectionSeats._objects.filter((s: any) => s.eventSeat || (!s.numberLeft && !s.numberRight && s.row));
    this.startRow = rowSeats.length ? Math.min(...rowSeats.map((s: any) => +s.row)) : 1;

    // Butaca de inicio: detectar el menor número de butaca en la primera fila
    const eventSeats = this.sectionSeats._objects.filter((s: any) => s.eventSeat);
    if (eventSeats.length) {
      const minRow = Math.min(...eventSeats.map((s: any) => +s.row));
      const firstRowSeats = eventSeats.filter((s: any) => +s.row === minRow);
      this.startSeat = Math.min(...firstRowSeats.map((s: any) => +s.seat));

      // Dirección y par/impar: se detectan de las butacas ya guardadas (no se restauran solas,
      // los checkboxes no persisten su propio estado) para que "Butaca de inicio por fila" y el
      // resto de acciones de numeración hereden el esquema REAL vigente, no el valor por defecto.
      const col1Seat = firstRowSeats.find((s: any) => +s.column === 1);
      const col2Seat = firstRowSeats.find((s: any) => +s.column === 2);
      if (col1Seat && col2Seat) {
        const s1 = +col1Seat.seat;
        const s2 = +col2Seat.seat;
        if (!isNaN(s1) && !isNaN(s2) && s1 !== s2) {
          this.directionRight = (s2 - s1) > 0;
          const step = Math.abs(s2 - s1);
          this.numeracionPar = step === 2 && s1 % 2 === 0;
          this.numeracionImpar = step === 2 && s1 % 2 !== 0;
        }
      }
    } else {
      this.startSeat = 1;
    }

    // Filas con butacas reales, para el selector "butaca de inicio por fila"
    const allRowLabels: number[] = eventSeats.map((s: any) => +s.row);
    this.rowLabels = allRowLabels
      .filter((row: number, index: number) => allRowLabels.indexOf(row) === index)
      .sort((a: number, b: number) => a - b);
    this.rowStartSeatOverrides = { ...(sgc.rowStartSeatOverrides || {}) };
    // Mantener la fila seleccionada si sigue existiendo; si no, limpiar la selección
    if (this.selectedRowForStart != null && !this.rowLabels.includes(this.selectedRowForStart)) {
      this.selectedRowForStart = null;
      this.rowStartSeatValue = null;
    } else if (this.selectedRowForStart != null) {
      this.onRowForStartSelected();
    }

    // Color actual de las butacas
    const firstSeatForColor = this.sectionSeats._objects.find((s: any) => s.eventSeat && s.isVisible !== false);
    if (firstSeatForColor) {
      const circle = firstSeatForColor._objects?.find((o: any) => o.type !== 'text');
      this.seatColor = circle?.fill || this.colorDefaultSeat || '#ffffff';
    }

    // Nivel: leer desde fabric object, con fallback escaneando seatSections por nombre
    this.areaNumber = this.sectionElement.area != null ? +this.sectionElement.area : null;
    if (this.areaNumber == null) {
      const allSections = this.generateMapService.getSeatSections();
      const found = Object.values(allSections).find((s: any) =>
        s.section?.name === this.valueName || +s.section?.id === +this.sectionNumber
      ) as any;
      if (found?.section?.level != null) {
        this.areaNumber = +found.section.level;
      }
    }
    // Coerción de tipos para manejar string vs number del API
    this.level = this.levels.find(nivel => +nivel.id === +this.areaNumber) || null;
  }

  activeEditing() {
    this.firstTime = true;
    this.activedEditing = true;
    this.activeEdit.emit(true);
  }

  changeVisibilityName() {
    this.sectionObj.set('visible', this.visibilityNameSection);

    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]?.section?.configuration?.titleConfiguration) {
          seatSections[this.sectionNumber].section.configuration.titleConfiguration.visible = this.visibilityNameSection;
          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar visibilidad del nombre de sección:', error);
      }
    }

    this.updateCanvas.emit();
  }

  editStartRow() {
    const seats = this.sectionSeats._objects.filter((s: any) => s.eventSeat);
    if (!seats.length) return;

    const currentMinRow = Math.min(...seats.map((s: any) => +s.row));
    const offset = +this.startRow - currentMinRow;
    if (offset === 0) return;

    // Re-indexar overrides de butaca de inicio por fila con el mismo offset, para que sigan
    // apuntando a la fila correcta tras el re-etiquetado.
    if (Object.keys(this.rowStartSeatOverrides).length) {
      const reKeyed: { [row: number]: number } = {};
      Object.entries(this.rowStartSeatOverrides).forEach(([row, val]) => { reKeyed[+row + offset] = val; });
      this.rowStartSeatOverrides = reKeyed;
      this.persistRowStartSeatOverrides();
    }
    this.rowLabels = this.rowLabels.map(r => r + offset);
    if (this.selectedRowForStart != null) this.selectedRowForStart += offset;

    // Actualizar fila en los asientos del canvas
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.eventSeat) {
        seatElement.set('row', +seatElement.row + offset);
      }
    });

    // Actualizar texto de leyendas de fila (izquierda y derecha)
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.numberLeft || seatElement.numberRight) {
        const textChild = seatElement._objects?.find((o: any) => o.type === 'text');
        if (textChild) {
          const current = parseInt(textChild.text, 10);
          if (!isNaN(current)) {
            textChild.set('text', (current + offset).toString());
          }
        }
      }
    });

    // Persistir en seatSections del servicio
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]) {
          seatSections[this.sectionNumber].elements.forEach((element: any) => {
            element.row = +element.row + offset;
            if (element.configuration) {
              element.configuration.originY = element.configuration.originY; // posición visual no cambia
            }
          });
          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar fila de inicio:', error);
      }
    }

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.canvas.renderAll();
    this.updateCanvas.emit();
  }

  // Invierte el orden de numeración de las filas (1..X ↔ X..1) reasignando a cada fila su
  // etiqueta espejo (min+max−row). No mueve butacas: solo cambia el número de fila de cada
  // butaca y el texto de las leyendas laterales, y persiste el nuevo estado.
  changeReverseRows() {
    const seats = this.sectionSeats._objects.filter((s: any) => s.eventSeat);
    if (!seats.length) return;

    const rowsArr = seats.map((s: any) => +s.row);
    const minRow = Math.min(...rowsArr);
    const maxRow = Math.max(...rowsArr);
    const sum = minRow + maxRow;
    if (minRow === maxRow) return; // una sola fila: nada que invertir

    // Re-indexar overrides de butaca de inicio por fila con el mismo espejo, para que sigan
    // apuntando a la fila física correcta tras la inversión.
    if (Object.keys(this.rowStartSeatOverrides).length) {
      const reKeyed: { [row: number]: number } = {};
      Object.entries(this.rowStartSeatOverrides).forEach(([row, val]) => { reKeyed[sum - +row] = val; });
      this.rowStartSeatOverrides = reKeyed;
      this.persistRowStartSeatOverrides();
    }
    this.rowLabels = this.rowLabels.map(r => sum - r);
    if (this.selectedRowForStart != null) this.selectedRowForStart = sum - this.selectedRowForStart;

    // Relabelar el número de fila de cada butaca
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.eventSeat) {
        seatElement.set('row', sum - +seatElement.row);
        seatElement.dirty = true;
      }
    });

    // Relabelar el texto de las leyendas de fila (izquierda y derecha)
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.numberLeft || seatElement.numberRight) {
        const textChild = seatElement._objects?.find((o: any) => o.type === 'text');
        if (textChild) {
          const current = parseInt(textChild.text, 10);
          if (!isNaN(current)) {
            textChild.set('text', (sum - current).toString());
            textChild.dirty = true;
          }
        }
      }
    });

    this.sectionSeats.set('reverseRows', this.reverseRows);

    // Persistir en seatSections del servicio
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections?.[this.sectionNumber]) {
      try {
        const seatSections = storedSections;
        seatSections[this.sectionNumber].elements.forEach((element: any) => {
          element.row = sum - +element.row;
        });
        const groupConfig = seatSections[this.sectionNumber].section?.configuration?.seatsGroupConfig;
        if (groupConfig) {
          groupConfig.reverseRows = this.reverseRows;
        }
        this.generateMapService.setSeatSections(seatSections);
      } catch (error) {
        console.error('Error al invertir el orden de filas:', error);
      }
    }

    this.sectionSeats.dirty = true;
    this.sectionElement.dirty = true;
    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.canvas.requestRenderAll();
    this.updateCanvas.emit();
  }

  // Aplica un nuevo nº de filas/columnas a una sección ya creada. Añade posiciones nuevas
  // (butacas visibles con el color del nivel) o recorta las sobrantes, conservando las
  // butacas existentes con toda su personalización (color, ocultas, nivel especial, número).
  // La reconstrucción visual la hace el padre a partir de seatSections.
  applyResize(newRows: number, newCols: number) {
    newRows = Math.max(1, Math.floor(+newRows || 0));
    newCols = Math.max(1, Math.floor(+newCols || 0));

    const storedSections = this.generateMapService.getSeatSections();
    const sectionData = storedSections?.[this.sectionNumber];
    if (!sectionData) return;

    // El tamaño de partida es el PERSISTIDO (refleja lo realmente renderizado). No usar
    // this.numRows/Cols: el binding [(ngModel)] ya los ha actualizado al valor nuevo antes
    // de disparar (change), así que compararlos entre sí siempre daría igual.
    const oldRows = +sectionData.section.rows || 1;
    const oldCols = +sectionData.section.columns || 1;
    if (newRows === oldRows && newCols === oldCols) return;

    // 1) Reconstruir el array de elementos conservando las butacas existentes
    sectionData.elements = this.buildResizedElements(sectionData, oldRows, oldCols, newRows, newCols);

    // 2) Actualizar el tamaño en la configuración de la sección
    sectionData.section.rows = newRows;
    sectionData.section.columns = newCols;
    const groupConfig = sectionData.section?.configuration?.seatsGroupConfig;
    if (groupConfig) {
      groupConfig.rows = newRows;
      groupConfig.columns = newCols;
    }
    this.generateMapService.setSeatSections(storedSections);

    this.numRows = newRows;
    this.numCols = newCols;

    // 3) El padre elimina el grupo antiguo del canvas, lo recrea desde seatSections y
    //    reasigna la selección sin recrear el componente (resincroniza vía ngOnChanges).
    this.rebuildSection.emit(this.sectionNumber);
  }

  applyRowsChange() { this.applyResize(this.numRows, this.numCols); }
  applyColsChange() { this.applyResize(this.numRows, this.numCols); }

  // Reconstruye el array de elementos (row-major) para el nuevo tamaño reutilizando cada
  // butaca por su posición física (fila, columna) —conservando color, ocultas, nivel especial
  // y número original de las que se quedan— y creando las nuevas. La numeración (filas,
  // butacas y dirección) se recalcula de forma determinista a partir del esquema DETECTADO en
  // las butacas actuales, de modo que las añadidas continúan la misma secuencia.
  private buildResizedElements(sectionData: any, oldRows: number, oldCols: number, newRows: number, newCols: number): any[] {
    const section = sectionData.section;
    const sectionId = section.id;
    const sectionName = section.name;
    const oldElements: any[] = sectionData.elements || [];

    // ── Detectar el esquema de numeración de FILAS ──
    // Etiqueta de fila por índice físico (0 = fila superior). El primer elemento de cada fila
    // almacena su etiqueta.
    const rowLabels: number[] = [];
    for (let i = 0; i < oldRows; i++) {
      const label = oldElements[i * oldCols]?.row;
      rowLabels.push(label != null ? +label : (i + 1));
    }
    const startRow = rowLabels.length ? Math.min(...rowLabels) : 1;
    // Orden invertido: la fila superior tiene una etiqueta mayor que la inferior.
    const reverseRows = oldRows >= 2
      ? rowLabels[0] > rowLabels[oldRows - 1]
      : !!this.reverseRows;

    // ── Detectar el esquema de numeración de BUTACAS (paso y dirección) ──
    // Comparando dos columnas contiguas de una fila: signo → dirección, |diff| → paso (1 normal, 2 par/impar).
    let step = 1;
    let directionRight = true;
    if (oldCols >= 2) {
      const s1 = +oldElements[0]?.seat;
      const s2 = +oldElements[1]?.seat;
      if (!isNaN(s1) && !isNaN(s2) && s1 !== s2) {
        directionRight = (s2 - s1) > 0;
        step = Math.min(2, Math.max(1, Math.abs(s2 - s1)));
      }
    }
    // El nº de butaca de inicio es el menor de la sección (dirCol = 1).
    const seatNums = oldElements.map((e: any) => +e.seat).filter((n: number) => !isNaN(n));
    const startSeat = seatNums.length ? Math.min(...seatNums) : 1;

    // Overrides de "butaca de inicio por fila": se emparejan por ÍNDICE FÍSICO (no por etiqueta
    // antigua), porque con reverseRows activo la etiqueta de una misma fila física puede cambiar
    // entre el tamaño viejo y el nuevo. Las filas que desaparecen con el resize se podan solas.
    const oldRowOverrides: { [row: number]: number } = section.configuration?.seatsGroupConfig?.rowStartSeatOverrides || {};
    const newRowOverrides: { [row: number]: number } = {};

    // Etiqueta de fila para el índice físico i según el esquema detectado.
    const rowLabelFor = (i: number) => reverseRows ? (startRow + (newRows - 1 - i)) : (startRow + i);
    // Nº de butaca para la columna física c (1..newCols) según dirección, paso y el "start" de esa fila.
    const seatNumberFor = (c: number, rowStart: number) => {
      const dirCol = directionRight ? c : (newCols - c + 1);
      return rowStart + (dirCol - 1) * step;
    };

    const newElements: any[] = [];
    for (let i = 0; i < newRows; i++) {
      const rowLabel = rowLabelFor(i);
      const oldOverride = i < oldRows ? oldRowOverrides[rowLabels[i]] : null;
      const rowStart = oldOverride != null ? this.normalizeStart(+oldOverride) : startSeat;
      if (oldOverride != null) {
        newRowOverrides[rowLabel] = oldOverride;
      }
      for (let c = 1; c <= newCols; c++) {
        const seatNumber = seatNumberFor(c, rowStart);
        // Reutilizar la butaca que estaba físicamente en (fila i, columna c) para conservar su
        // configuración; solo se reescribe la etiqueta/numeración según el esquema.
        const existing = (i < oldRows && c <= oldCols) ? oldElements[i * oldCols + (c - 1)] : null;
        if (existing) {
          existing.row = rowLabel;
          existing.column = c;
          existing.seat = seatNumber;
          existing.section = sectionId;
          if (existing.configuration?.section) {
            existing.configuration.section = { id: sectionId, name: sectionName };
          }
          newElements.push(existing);
        } else {
          newElements.push({
            id: null,
            seat: seatNumber,
            row: rowLabel,
            column: c,
            section: sectionId,
            configuration: {
              eventSeat: true,
              isVisible: true,
              section: { id: sectionId, name: sectionName },
              hidden: false,
              color: section.color,
              special_color: null,
              special_level: null,
            }
          });
        }
      }
    }

    const sgc = section.configuration?.seatsGroupConfig;
    if (sgc) sgc.rowStartSeatOverrides = newRowOverrides;

    return newElements;
  }

  // Ajusta un nº de inicio a par/impar según los checkboxes de sección (mismo criterio siempre).
  private normalizeStart(start: number): number {
    const s = +start;
    if (this.numeracionPar) return s % 2 === 0 ? s : s + 1;
    if (this.numeracionImpar) return s % 2 !== 0 ? s : s + 1;
    return s;
  }

  // Nº de butaca para una columna dada, según dirección/paso GLOBALES de la sección.
  private computeSeatValue(column: number, columns: number, effectiveStart: number): number {
    const col = this.directionRight ? column : (columns - column + 1);
    const step = (this.numeracionImpar || this.numeracionPar) ? 2 : 1;
    return effectiveStart + (col - 1) * step;
  }

  // Escribe el valor en el fabric object (círculo + texto).
  private setSeatValue(seatElement: any, value: number) {
    seatElement.set('seat', value);
    const elementText = seatElement._objects.find((v: any) => v.type === 'text');
    if (elementText) {
      elementText.set('text', value.toString());
      elementText.dirty = true;
    }
    seatElement.dirty = true;
  }

  // Cierre común: marcar dirty, persistir y repintar.
  private finishNumberingUpdate() {
    this.sectionSeats.dirty = true;
    this.sectionElement.dirty = true;
    this.persistSeatNumbers();
    this.canvas.requestRenderAll();
    this.updateCanvas.emit();
  }

  // Aplica el esquema de numeración a TODA la sección: cada butaca usa el override de su fila
  // (si existe) o el startSeat global. Sustituye la lógica que antes estaba duplicada 4 veces.
  private applySectionNumbering() {
    const columns = this.sectionSeats.columns;
    const effectiveStart = this.normalizeStart(this.startSeat);
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (!seatElement.eventSeat) return;
      const override = this.rowStartSeatOverrides[+seatElement.row];
      const rowStart = override != null ? this.normalizeStart(+override) : effectiveStart;
      this.setSeatValue(seatElement, this.computeSeatValue(seatElement.column, columns, rowStart));
    });
    this.finishNumberingUpdate();
  }

  // Aplica la fórmula SOLO a una fila concreta (paso/dirección heredados de la sección).
  private applyRowNumbering(rowLabel: number, start: number) {
    const columns = this.sectionSeats.columns;
    const effectiveStart = this.normalizeStart(+start);
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.eventSeat && +seatElement.row === +rowLabel) {
        this.setSeatValue(seatElement, this.computeSeatValue(seatElement.column, columns, effectiveStart));
      }
    });
  }

  private persistRowStartSeatOverrides() {
    const storedSections = this.generateMapService.getSeatSections();
    const groupConfig = storedSections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!groupConfig) return;
    groupConfig.rowStartSeatOverrides = { ...this.rowStartSeatOverrides };
    this.generateMapService.setSeatSections(storedSections);
  }

  editStartSeat() {
    this.applySectionNumbering();
  }

  // Repuebla rowStartSeatValue al cambiar de fila en el dropdown: si hay override, lo muestra;
  // si no, muestra la butaca de inicio ACTUAL de esa fila (mismo criterio que getValuesObjects
  // usa para startSeat de sección), para que el input arranque con un valor útil.
  onRowForStartSelected() {
    if (this.selectedRowForStart == null) { this.rowStartSeatValue = null; return; }
    const override = this.rowStartSeatOverrides[this.selectedRowForStart];
    if (override != null) { this.rowStartSeatValue = +override; return; }
    const rowSeats = this.sectionSeats._objects.filter(
      (s: any) => s.eventSeat && +s.row === this.selectedRowForStart
    );
    this.rowStartSeatValue = rowSeats.length ? Math.min(...rowSeats.map((s: any) => +s.seat)) : this.startSeat;
  }

  applyRowStartSeat() {
    if (this.selectedRowForStart == null || this.rowStartSeatValue == null) return;
    const rowLabel = +this.selectedRowForStart;
    const start = +this.rowStartSeatValue;
    this.applyRowNumbering(rowLabel, start);
    this.rowStartSeatOverrides[rowLabel] = start;
    this.persistRowStartSeatOverrides();
    this.finishNumberingUpdate();
  }

  clearRowStartSeatOverride() {
    if (this.selectedRowForStart == null) return;
    const rowLabel = +this.selectedRowForStart;
    if (this.rowStartSeatOverrides[rowLabel] == null) return;
    delete this.rowStartSeatOverrides[rowLabel];
    this.applyRowNumbering(rowLabel, this.startSeat);
    this.persistRowStartSeatOverrides();
    this.onRowForStartSelected();
    this.finishNumberingUpdate();
  }

  changeRows() {
    let rows = this.sectionSeats.filas;
    this.sectionSeats._objects.forEach(seatElement => {
      let rowSeat = +seatElement.row;
      if (seatElement.row) {
        let cal = rows - rowSeat + 1;
        seatElement.set('row', cal);
      }
    });
    this.updateCanvas.emit();
  }

  editName() {
    this.sectionObj.set('text', this.valueName);
    let section = { id: this.sectionNumber, name: this.valueName };
    this.sectionSeats.set('section', section)
    this.sectionSeats._objects.forEach(seatElement => {
      if (seatElement.eventSeat) {
        seatElement.set('section', section);
      }
    });

    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        seatSections[this.sectionNumber].section.name = this.valueName;
        seatSections[this.sectionNumber].elements.forEach(element => {
          if (element.section) {
            element.section.name = this.valueName;
          }
        });

        this.generateMapService.setSeatSections(seatSections);

      } catch (error) {
        // if (AppSettings.DEBUG) {
        console.error('Error al parsear seatSection desde localStorage:', error);
        // }
      }
    }

    this.sectionSeats.addWithUpdate();
    this.updateCanvas.emit();
  }

  editId() {
    let section = { id: this.sectionNumber, name: this.valueName };
    this.sectionSeats.set('section', section)
    this.sectionSeats._objects.forEach(seatElement => {
      if (seatElement.eventSeat) {
        seatElement.set('section', section);
      }
    });
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  compareLevels(a: any, b: any): boolean {
    if (!a || !b) return false;
    return +a.id === +b.id;
  }

  editArea() {
    // areaNumber ahora contiene el nivel.id seleccionado
    this.areaNumber = this.level.id;
    // Encontrar el nivel completo para obtener el nombre si es necesario
    const selectedLevel = this.levels.find(nivel => nivel.id === this.areaNumber);

    // Aquí puedes agregar la lógica adicional que necesites
    // Por ejemplo, actualizar la sección con el nuevo nivel
    this.sectionElement.set('area', this.areaNumber);
    this.sectionSeats.set('area', this.areaNumber);
    this.sectionSeats._objects.forEach(seatElement => {
      if (seatElement.eventSeat) {
        seatElement.set('area', this.areaNumber);
      }
    });

    // Actualizar todos los asientos para reflejar el cambio de nivel (excepto los que tienen nivel especial)
    this.seatColor = this.level.color;
    this.sectionSeats._objects.forEach(seatElement => {
      if (seatElement.eventSeat && !seatElement.specialLevel) {
        changeSeatColor(seatElement, this.level.color);
      }
    });

    // Actualizar la seccion de las butacas en el mapa
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        seatSections[this.sectionNumber].section.level = this.areaNumber;
        seatSections[this.sectionNumber].section.color = this.level.color;

        this.generateMapService.setSeatSections(seatSections);

      } catch (error) {
        // if (AppSettings.DEBUG) {
        console.error('Error al parsear seatSection desde localStorage:', error);
        // }
      }
    }

    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  editSeatColor() {
    this.sectionSeats._objects.forEach(seatElement => {
      // Saltar butacas con nivel especial propio; solo repintar las del nivel de la sección
      if (seatElement.eventSeat && seatElement.isVisible !== false && !seatElement.specialLevel) {
        changeSeatColor(seatElement, this.seatColor);
      }
    });
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections?.[this.sectionNumber]) {
      storedSections[this.sectionNumber].section.color = this.seatColor;
      // Limpiar special_color solo de elementos sin special_level para que section.color sea
      // la fuente de verdad al recargar para esos asientos.
      storedSections[this.sectionNumber].elements?.forEach((el: any) => {
        if (el?.configuration && !el.configuration.special_level) {
          el.configuration.special_color = null;
        }
      });
      this.generateMapService.setSeatSections(storedSections);
    }
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  editRowsColumns() {
    const columns = this.sectionSeats.columns;
    const rows = this.sectionSeats.rows;
    let newGroup = this.addSeat(rows, columns);
    this.sectionElement.remove(this.sectionSeats);
    this.sectionElement.addWithUpdate();
    this.sectionElement.add(newGroup);
    this.sectionElement.addWithUpdate();
    this.sectionSeats = newGroup;
    this.updateCanvas.emit();
  }

  editTilt(value: any) {
    // let arrayBefore = JSON.parse(this.oldSeatsEl).objects;
    // let columns = +this.sectionSeats.columns;
    // this.sectionSeats._objects.forEach((seatElement, index) => {
    //   if (value < 0) {
    //     seatElement.set('originY', arrayBefore[index].originY + (value * (columns - arrayBefore[index].column)));
    //   } else {
    //     seatElement.set('originY', arrayBefore[index].originY - (value * arrayBefore[index].column));
    //   }
    // });

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  editCurve() {
    // En modo radial/elíptico la curvatura no es una parábola local: se recalcula la sección
    // como arcos concéntricos alrededor de su propio centro externo.
    if (this.curvatureMode === 'radial' || this.curvatureMode === 'elliptical') { this.relayoutRadial(); return; }

    const curvature = +this.valueCurvature;
    const columns = this.sectionSeats.columns;
    const rows = this.sectionSeats.rows;
    const midCol = (columns - 1) / 2;

    // Obtener la posición base (sin curvatura) de cada fila
    // Recorremos todos los objetos del grupo de asientos
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.eventSeat || seatElement.numberLeft || seatElement.numberRight) {
        let col: number;
        if (seatElement.numberLeft) {
          col = -1; // Leyenda izquierda: una posición antes del primer asiento
        } else if (seatElement.numberRight) {
          col = columns; // Leyenda derecha: una posición después del último asiento
        } else {
          col = seatElement.column - 1; // Columnas 0-indexed
        }

        // Calcular el offset parabólico basado en la distancia al centro
        const distFromCenter = (col - midCol) / (midCol || 1);
        const curveOffset = curvature * distFromCenter * distFromCenter * 0.5;

        // Guardar posición base si no existe
        if (seatElement._baseOriginY == null) {
          seatElement._baseOriginY = seatElement.originY;
        }

        seatElement.set('originY', seatElement._baseOriginY + curveOffset);
      }
    });

    this.sectionSeats.set('curvature', curvature);

    // Persistir en storage
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]) {
          seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.curvature = curvature;
          // Actualizar las posiciones de los elementos
          seatSections[this.sectionNumber].elements.forEach((element: any) => {
            const col = element.column - 1;
            const distFromCenter = (col - midCol) / (midCol || 1);
            const curveOffset = curvature * distFromCenter * distFromCenter * 0.5;
            if (element.configuration._baseOriginY == null) {
              element.configuration._baseOriginY = element.configuration.originY;
            }
            element.configuration.originY = element.configuration._baseOriginY + curveOffset;
          });
          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar curvatura:', error);
      }
    }

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  editSpacing() {
    const colSpacing = +this.columnSpacing;
    const rowSpacing = +this.rowSpacing;
    const columns = this.sectionSeats.columns;

    // En modo radial/elíptico el espaciado alimenta el arco (paso radial de filas y angular de
    // columnas): se guarda en la config y se recompone la sección; no aplica la ruta de escalado
    // del grid plano.
    if (this.curvatureMode === 'radial' || this.curvatureMode === 'elliptical') {
      const sections = this.generateMapService.getSeatSections();
      const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
      if (sgc) {
        sgc.columnSpacing = colSpacing;
        sgc.rowSpacing = rowSpacing;
        this.generateMapService.setSeatSections(sections);
      }
      this.relayoutRadial();
      return;
    }

    // Con filas personalizadas activas, el reescalado en vivo por ratio de más abajo (y el
    // recálculo de elements[].configuration.originY) asumen espaciado uniforme y corromperían
    // los overrides por fila. En ese caso, igual que en radial, se persiste y se reconstruye
    // la sección entera desde cero (addGroupSeats ya sabe combinar overrides + global).
    const sectionsCheck = this.generateMapService.getSeatSections();
    const sgcCheck = sectionsCheck?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    const hasRowOverrides = !!sgcCheck?.rowSpacingPerRowEnabled && (
      Object.keys(sgcCheck?.rowSpacingOverrides || {}).length > 0
      || Object.keys(sgcCheck?.columnSpacingOverrides || {}).length > 0
      || Object.keys(sgcCheck?.rowOffsetXOverrides || {}).length > 0
    );
    if (hasRowOverrides) {
      sgcCheck.columnSpacing = colSpacing;
      sgcCheck.rowSpacing = rowSpacing;
      this.generateMapService.setSeatSections(sectionsCheck);
      this.rebuildSection.emit(this.sectionNumber);
      return;
    }

    // Guardar las posiciones originales y el spacing que tenían en la primera llamada
    if (this.sectionSeats._spacingBaseColSpacing == null) {
      this.sectionSeats._spacingBaseColSpacing = this.sectionSeats.columnSpacing || 1.2;
      this.sectionSeats._spacingBaseRowSpacing = this.sectionSeats.rowSpacing || 1.2;
    }
    const baseColSpacing = this.sectionSeats._spacingBaseColSpacing;
    const baseRowSpacing = this.sectionSeats._spacingBaseRowSpacing;
    const colRatio = colSpacing / baseColSpacing;
    const rowRatio = rowSpacing / baseRowSpacing;

    this.sectionSeats._objects.forEach((el: any) => {
      if (el._spacingBaseOriginX == null) {
        el._spacingBaseOriginX = el.originX;
      }
      if (el._spacingBaseOriginY == null) {
        // Usar la base de curvatura si existe (= originY sin curvatura)
        el._spacingBaseOriginY = el._baseOriginY != null ? el._baseOriginY : el.originY;
      }
    });

    // Encontrar el ancla Y (fila superior, mayor originY entre las posiciones base)
    const allBaseYs = this.sectionSeats._objects
      .filter((s: any) => s.eventSeat || s.numberLeft || s.numberRight)
      .map((s: any) => s._spacingBaseOriginY);
    const anchorY = Math.max(...allBaseYs);

    this.sectionSeats._objects.forEach((el: any) => {
      if (!(el.eventSeat || el.numberLeft || el.numberRight)) return;

      const baseX = el._spacingBaseOriginX;
      const baseY = el._spacingBaseOriginY;

      // Escalar posición horizontal (ancla en originX=0, la leyenda izquierda)
      const newOriginX = baseX * colRatio;

      // Escalar posición vertical del grid (ancla en la fila superior)
      const gridOffset = baseY - anchorY; // valor negativo (las filas van hacia abajo)
      const newGridY = anchorY + gridOffset * rowRatio;

      // Preservar el offset de curvatura
      const curveOffset = el._baseOriginY != null ? (el.originY - el._baseOriginY) : 0;

      el.set('originX', newOriginX);
      el.set('originY', newGridY + curveOffset);

      // Actualizar la base de curvatura para que refleje la nueva posición del grid
      if (el._baseOriginY != null) {
        el._baseOriginY = newGridY;
      }
    });

    this.sectionSeats.set('columnSpacing', colSpacing);
    this.sectionSeats.set('rowSpacing', rowSpacing);

    // Persistir en storage
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]) {
          const oldColSpacing = seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.columnSpacing || 1.2;
          const oldRowSpacing = seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.rowSpacing || 1.2;

          seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.columnSpacing = colSpacing;
          seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.rowSpacing = rowSpacing;

          // Actualizar posiciones guardadas de los elementos para que persistan correctamente
          const elements = seatSections[this.sectionNumber].elements;
          const uniqueRows = [...new Set(elements.map((e: any) => +e.row))].sort((a: number, b: number) => a - b);

          elements.forEach((element: any) => {
            const col = element.column - 1;
            const rowIdx = uniqueRows.indexOf(+element.row);

            // Calcular offset de curvatura desde las posiciones antiguas
            const expectedOldOriginY = 10 - rowIdx * oldRowSpacing;
            const curveOffset = element.configuration.originY - expectedOldOriginY;

            // Nuevas posiciones con el nuevo espaciado
            element.configuration.originX = -(col + 1) * colSpacing;
            element.configuration.originY = 10 - rowIdx * rowSpacing + curveOffset;

            // Actualizar base de curvatura
            if (element.configuration._baseOriginY != null) {
              element.configuration._baseOriginY = 10 - rowIdx * rowSpacing;
            }
          });

          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar espaciado:', error);
      }
    }

    // Recalcular el bounding box del grupo para que crezca/encoja
    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.canvas.requestRenderAll();
    this.updateCanvas.emit();
  }

  // Activa/desactiva el modo de espaciado por fila. No borra los overrides guardados al
  // desactivar (solo deja de aplicarlos, ver addGroupSeats), así que reactivarlo restaura los
  // valores previos sin que el usuario tenga que volver a introducirlos.
  toggleRowSpacingPerRow(enabled: boolean) {
    this.rowSpacingPerRow = enabled;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!sgc) return;
    sgc.rowSpacingPerRowEnabled = enabled;
    this.generateMapService.setSeatSections(sections);
    if (this.selectedRowSpacingPosition == null && this.rowsForSpacing.length) {
      this.selectedRowSpacingPosition = this.defaultRowSpacingPosition();
    }
    this.onSelectRowForSpacing();
    this.rebuildSection.emit(this.sectionNumber);
  }

  // Preferir la posición 2 (la primera fila que SÍ tiene "fila anterior") como selección por
  // defecto: así, al activar el modo por fila, se ven de entrada tanto el campo de espacio entre
  // butacas como el de espacio respecto a la fila anterior (este último se oculta para la fila 1).
  // Si la sección solo tiene una fila, no queda otra que la posición 1.
  private defaultRowSpacingPosition(): number | null {
    if (!this.rowsForSpacing.length) return null;
    const secondRow = this.rowsForSpacing.find(r => r.position === 2);
    return secondRow ? secondRow.position : this.rowsForSpacing[0].position;
  }

  onSelectRowForSpacing() {
    if (this.selectedRowSpacingPosition == null) {
      this.selectedRowSpacingValue = null;
      this.selectedColumnSpacingValue = null;
      this.selectedRowOffsetXValue = null;
      return;
    }
    const rowOverride = this.rowSpacingOverrides[this.selectedRowSpacingPosition];
    this.selectedRowSpacingValue = rowOverride != null ? rowOverride : this.rowSpacing;
    const colOverride = this.columnSpacingOverrides[this.selectedRowSpacingPosition];
    this.selectedColumnSpacingValue = colOverride != null ? colOverride : this.columnSpacing;
    const offsetOverride = this.rowOffsetXOverrides[this.selectedRowSpacingPosition];
    this.selectedRowOffsetXValue = offsetOverride != null ? offsetOverride : 0;
  }

  // Reconstruye la sección entera desde cero (como applyResize/relayoutRadial) en vez de
  // reposicionar butacas a mano: así el resultado en pantalla siempre coincide exactamente con
  // lo que addGroupSeats recompondrá al guardar/recargar.
  editRowSpacing() {
    if (this.selectedRowSpacingPosition == null || this.selectedRowSpacingValue == null) return;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!sgc) return;
    sgc.rowSpacingOverrides = sgc.rowSpacingOverrides || {};
    sgc.rowSpacingOverrides[this.selectedRowSpacingPosition] = +this.selectedRowSpacingValue;
    this.rowSpacingOverrides = sgc.rowSpacingOverrides;
    this.generateMapService.setSeatSections(sections);
    this.rebuildSection.emit(this.sectionNumber);
  }

  resetRowSpacing() {
    if (this.selectedRowSpacingPosition == null) return;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (sgc?.rowSpacingOverrides) {
      delete sgc.rowSpacingOverrides[this.selectedRowSpacingPosition];
      this.rowSpacingOverrides = { ...sgc.rowSpacingOverrides };
      this.generateMapService.setSeatSections(sections);
    }
    this.selectedRowSpacingValue = this.rowSpacing;
    this.rebuildSection.emit(this.sectionNumber);
  }

  // Espacio horizontal entre butacas dentro de la fila seleccionada (independiente del espacio
  // vertical respecto a la fila anterior). Mismo patrón de rebuild que editRowSpacing().
  editRowColumnSpacing() {
    if (this.selectedRowSpacingPosition == null || this.selectedColumnSpacingValue == null) return;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!sgc) return;
    sgc.columnSpacingOverrides = sgc.columnSpacingOverrides || {};
    sgc.columnSpacingOverrides[this.selectedRowSpacingPosition] = +this.selectedColumnSpacingValue;
    this.columnSpacingOverrides = sgc.columnSpacingOverrides;
    this.generateMapService.setSeatSections(sections);
    this.rebuildSection.emit(this.sectionNumber);
  }

  resetRowColumnSpacing() {
    if (this.selectedRowSpacingPosition == null) return;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (sgc?.columnSpacingOverrides) {
      delete sgc.columnSpacingOverrides[this.selectedRowSpacingPosition];
      this.columnSpacingOverrides = { ...sgc.columnSpacingOverrides };
      this.generateMapService.setSeatSections(sections);
    }
    this.selectedColumnSpacingValue = this.columnSpacing;
    this.rebuildSection.emit(this.sectionNumber);
  }

  // Desplazamiento horizontal manual de la fila entera (butacas + leyendas), para recolocarla
  // tras ensanchar/estrechar su espacio entre butacas sin afectar a las demás filas.
  editRowOffsetX() {
    if (this.selectedRowSpacingPosition == null || this.selectedRowOffsetXValue == null) return;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!sgc) return;
    sgc.rowOffsetXOverrides = sgc.rowOffsetXOverrides || {};
    sgc.rowOffsetXOverrides[this.selectedRowSpacingPosition] = +this.selectedRowOffsetXValue;
    this.rowOffsetXOverrides = sgc.rowOffsetXOverrides;
    this.generateMapService.setSeatSections(sections);
    this.rebuildSection.emit(this.sectionNumber);
  }

  resetRowOffsetX() {
    if (this.selectedRowSpacingPosition == null) return;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (sgc?.rowOffsetXOverrides) {
      delete sgc.rowOffsetXOverrides[this.selectedRowSpacingPosition];
      this.rowOffsetXOverrides = { ...sgc.rowOffsetXOverrides };
      this.generateMapService.setSeatSections(sections);
    }
    this.selectedRowOffsetXValue = 0;
    this.rebuildSection.emit(this.sectionNumber);
  }

  editSeatNumberAngle() {
    const angle = +this.seatNumberAngle;
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.eventSeat) {
        const textChild = seatElement._objects?.find((o: any) => o.type === 'text');
        if (textChild) {
          textChild.set('angle', angle);
        }
      }
    });
    this.sectionSeats.set('seatNumberAngle', angle);

    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]) {
          seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.seatNumberAngle = angle;
          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar ángulo de números de butaca:', error);
      }
    }

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  editNumberAngle() {
    const angle = +this.numberAngle;
    this.sectionSeats._objects.forEach((seatElement: any) => {
      if (seatElement.numberLeft || seatElement.numberRight) {
        const textChild = seatElement._objects?.find((o: any) => o.type === 'text');
        if (textChild) {
          textChild.set('angle', angle);
        }
      }
    });
    this.sectionSeats.set('numberAngle', angle);

    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]) {
          seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.numberAngle = angle;
          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar ángulo de números:', error);
      }
    }

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  editRotation(value: any) {
    const angle = parseInt(value, 10);
    this.sectionElement.set('angle', angle).setCoords();

    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        if (seatSections[this.sectionNumber]) {
          const cfg = seatSections[this.sectionNumber].section.configuration;
          cfg.angle = angle;
          // Secciones radiales/elípticas con centro de curvatura: el ángulo del grupo se
          // recalcula en cada reconstrucción (F5, undo, mover C…) a partir de la posición y de
          // C (ver generateMapService.addGroupSeats), ignorando `configuration.angle` tal cual.
          // Igual que en generate-canvas.createOrUpdateSectionData (rotar arrastrando el
          // tirador), hay que guardar el ajuste manual por separado en
          // seatsGroupConfig.manualAngleOffsetDeg para que este slider también sobreviva a la
          // reconstrucción.
          const sgc = cfg.seatsGroupConfig;
          const isRadial = sgc && (sgc.curvatureMode === 'radial' || sgc.curvatureMode === 'elliptical') && !!sgc.curvatureCenter;
          if (isRadial) {
            const baseAngle = this.generateMapService.computeRadialBaseAngleDeg(
              this.sectionElement.left, this.sectionElement.top, sgc.curvatureCenter
            );
            sgc.manualAngleOffsetDeg = angle - baseAngle;
          }
          this.generateMapService.setSeatSections(seatSections);
        }
      } catch (error) {
        console.error('Error al actualizar ángulo de sección:', error);
      }
    }

    this.updateCanvas.emit();
  }

  ngOnDestroy(): void {
    this.removeCurvatureMarker();
  }

  // ==== Curvatura radial/elíptica: modo, centro propio y recálculo ====

  // Cambia entre curvatura parabólica (clásica), radial (arcos concéntricos, círculo perfecto) y
  // elíptica (igual que radial pero con achatamiento/rotación del óvalo).
  setCurvatureMode(mode: 'parabolic' | 'radial' | 'elliptical') {
    if (mode === this.curvatureMode) return;
    this.curvatureMode = mode;
    const sections = this.generateMapService.getSeatSections();
    const sgc = sections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!sgc) return;
    sgc.curvatureMode = mode;
    if (mode === 'radial' || mode === 'elliptical') {
      if (!this.curvatureCenter) this.curvatureCenter = this.getDefaultCenter();
      sgc.curvatureCenter = { x: this.curvatureCenter.x, y: this.curvatureCenter.y };
      sgc.baseRadius = null;      // null => se deriva en vivo de la distancia sección↔centro
      sgc.radialInvert = !!this.radialInvert;
      // El radial es siempre círculo perfecto; solo el elíptico admite achatar/rotar el óvalo.
      sgc.ellipseAspect = mode === 'elliptical' ? this.ellipseAspect : 1;
      sgc.ellipseRotation = mode === 'elliptical' ? this.ellipseRotation : 0;
      this.generateMapService.setSeatSections(sections);
      // OJO: no reconstruir todavía. Si se reconstruye ya con el centro por defecto (viewport),
      // la sección "salta" de golpe (distancia/rotación) antes de que el usuario haya podido
      // elegir dónde va el centro. Solo se muestra el marcador arrastrable; la reconstrucción
      // real ocurre al soltar el marcador en su sitio (ver commitCurvatureCenterToAll).
      this.showCurvatureCenter = true;
      this.createCurvatureMarker();
    } else {
      this.removeCurvatureMarker();
      this.showCurvatureCenter = false;
      this.generateMapService.setSeatSections(sections);
      this.rebuildSection.emit(this.sectionNumber);
    }
  }

  // Recalcula ESTA sección como arcos radiales/elípticos tras cambiar radio/aspecto/rotación/
  // inversión/espaciado.
  relayoutRadial() {
    const sections = this.generateMapService.getSeatSections();
    const cfg = sections?.[this.sectionNumber]?.section?.configuration;
    if (!cfg?.seatsGroupConfig) return;
    const sgc = cfg.seatsGroupConfig;
    if (!this.curvatureCenter) this.curvatureCenter = this.getDefaultCenter();
    const isElliptical = this.curvatureMode === 'elliptical';
    sgc.curvatureMode = this.curvatureMode;
    sgc.curvatureCenter = { x: this.curvatureCenter.x, y: this.curvatureCenter.y };
    // Radio numérico explícito (canvas). Si el campo está vacío/0, se deriva en vivo de la
    // distancia actual sección↔centro (la sección no se mueve, así que esto es estable).
    sgc.baseRadius = (this.baseRadius != null && +this.baseRadius > 0) ? +this.baseRadius : null;
    sgc.radialInvert = !!this.radialInvert;
    // El radial es siempre círculo perfecto; solo el elíptico admite achatar/rotar el óvalo.
    sgc.ellipseAspect = isElliptical ? ((+this.ellipseAspect > 0) ? +this.ellipseAspect : 1) : 1;
    sgc.ellipseRotation = isElliptical ? (+this.ellipseRotation || 0) : 0;
    this.generateMapService.setSeatSections(sections);
    this.rebuildSection.emit(this.sectionNumber);
  }

  setBaseRadius() { if (this.curvatureMode === 'radial' || this.curvatureMode === 'elliptical') this.relayoutRadial(); }
  toggleRadialInvert() { this.radialInvert = !this.radialInvert; if (this.curvatureMode === 'radial' || this.curvatureMode === 'elliptical') this.relayoutRadial(); }
  setEllipseAspect() { if (this.curvatureMode === 'elliptical') this.relayoutRadial(); }
  setEllipseRotation() { if (this.curvatureMode === 'elliptical') this.relayoutRadial(); }

  // Centro por defecto = centro del viewport actual (en coords de canvas, deshaciendo zoom/pan).
  private getDefaultCenter(): { x: number, y: number } {
    const vpt = this.canvas?.viewportTransform || [1, 0, 0, 1, 0, 0];
    const w = this.canvas?.getWidth?.() || 800;
    const h = this.canvas?.getHeight?.() || 600;
    return { x: (w / 2 - vpt[4]) / (vpt[0] || 1), y: (h / 2 - vpt[5]) / (vpt[3] || 1) };
  }

  // Muestra/oculta el marcador arrastrable del centro de curvatura.
  toggleCurvatureCenter() {
    this.showCurvatureCenter = !this.showCurvatureCenter;
    if (this.showCurvatureCenter) {
      this.createCurvatureMarker();
    } else {
      this.removeCurvatureMarker(true);
    }
  }

  private createCurvatureMarker() {
    if (!this.canvas || this.curvatureMarker) return;
    if (!this.curvatureCenter) this.curvatureCenter = this.getDefaultCenter();
    const p = this.curvatureCenter;
    const size = 40;
    const circle = new fabric.Circle({
      radius: size, fill: 'rgba(255,77,128,0.12)', stroke: '#FF4D80', strokeWidth: 2,
      originX: 'center', originY: 'center',
    });
    const hLine = new fabric.Line([-size, 0, size, 0], { stroke: '#FF4D80', strokeWidth: 2 });
    const vLine = new fabric.Line([0, -size, 0, size], { stroke: '#FF4D80', strokeWidth: 2 });
    this.curvatureMarker = new fabric.Group([circle, hLine, vLine], {
      left: p.x, top: p.y, originX: 'center', originY: 'center',
      hasControls: false, hasBorders: false, selectable: true, evented: true,
      hoverCursor: 'move', lockRotation: true, lockScalingX: true, lockScalingY: true,
      isCurvatureCenter: true, excludeFromExport: true,
    } as any);
    (this.canvas as any)._pivotMode = true;
    this.canvas.add(this.curvatureMarker);
    this.curvatureMarker.bringToFront();
    (this.canvas as any)._pivotInternal = true;
    this.canvas.setActiveObject(this.curvatureMarker);
    (this.canvas as any)._pivotInternal = false;

    this.curvatureMovingHandler = (e: any) => {
      if (e.target === this.curvatureMarker) {
        this.curvatureCenter = { x: e.target.left, y: e.target.top };
      }
    };
    this.canvas.on('object:moving', this.curvatureMovingHandler);
    // Al soltar el marcador, propagar C a todas las secciones radiales y recomponerlas.
    this.curvatureUpHandler = (e: any) => {
      if (e.target === this.curvatureMarker) this.commitCurvatureCenterToAll();
    };
    this.canvas.on('mouse:up', this.curvatureUpHandler);

    // Colocar el centro justo donde el usuario haga clic en el mapa, en vez de tener que buscar y
    // arrastrar el marcador (que puede aparecer en una zona del lienzo fuera de donde se está
    // mirando). El arrastre del marcador sigue disponible para el ajuste fino.
    this.curvaturePlaceHandler = (opt: any) => {
      if (!this.showCurvatureCenter || !this.curvatureMarker) return;
      // Clic/arrastre sobre el propio marcador: es un ajuste fino, no una recolocación.
      if (opt.target === this.curvatureMarker) return;
      // absolutePointer = coords de lienzo (deshace zoom/pan), igual que marker.left/top y curvatureCenter.
      const p = opt.absolutePointer;
      if (!p) return;
      this.curvatureCenter = { x: p.x, y: p.y };
      this.curvatureMarker.set({ left: p.x, top: p.y });
      this.curvatureMarker.setCoords();
      this.curvatureMarker.bringToFront();
      (this.canvas as any)._pivotInternal = true;
      this.canvas.setActiveObject(this.curvatureMarker);
      (this.canvas as any)._pivotInternal = false;
      this.commitCurvatureCenterToAll();
      this.canvas.requestRenderAll();
    };
    this.canvas.on('mouse:down', this.curvaturePlaceHandler);
    this.canvas.requestRenderAll();
  }

  private removeCurvatureMarker(reselect: boolean = false) {
    if (this.canvas && this.curvatureMovingHandler) {
      this.canvas.off('object:moving', this.curvatureMovingHandler);
      this.curvatureMovingHandler = null;
    }
    if (this.canvas && this.curvatureUpHandler) {
      this.canvas.off('mouse:up', this.curvatureUpHandler);
      this.curvatureUpHandler = null;
    }
    if (this.canvas && this.curvaturePlaceHandler) {
      this.canvas.off('mouse:down', this.curvaturePlaceHandler);
      this.curvaturePlaceHandler = null;
    }
    if (this.canvas) (this.canvas as any)._pivotInternal = true;
    if (this.canvas && this.curvatureMarker) {
      this.canvas.remove(this.curvatureMarker);
    }
    if (this.canvas) {
      (this.canvas as any)._pivotMode = false;
      if (reselect && this.sectionElement) this.canvas.setActiveObject(this.sectionElement);
      (this.canvas as any)._pivotInternal = false;
      this.canvas.requestRenderAll();
    }
    this.curvatureMarker = null;
  }

  // Escribe el centro de curvatura SOLO en esta sección y pide reconstruirla.
  private commitCurvatureCenterToAll() {
    if (!this.curvatureCenter) return;
    const sections = this.generateMapService.getSeatSections();
    if (!sections) return;
    const sgc = sections[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (sgc && (sgc.curvatureMode === 'radial' || sgc.curvatureMode === 'elliptical')) {
      sgc.curvatureCenter = { x: this.curvatureCenter.x, y: this.curvatureCenter.y };
      // El baseRadius explícito (si el usuario puso uno) se deja tal cual; si no hay ninguno
      // (null), generate-map.service lo deriva en vivo de la distancia sección↔C en cada render.
      // La sección en sí (config.left/top) no se toca aquí ni en el render: solo cambia su radio/
      // orientación relativos al nuevo centro, nunca su posición en el canvas.
    }
    this.generateMapService.setSeatSections(sections);
    this.rebuildRadialSections.emit(this.sectionNumber);
  }

  applyChanges() {
    this.getValuesObjects();
    this.activedEditing = false;
    this.updateCanvas.emit();
  }

  applyHiddenChanges() {
    // Desactivar modo selección de ocultos
    this.selectingInvisibleMode = false;
    this.setHiddenSectionMode.emit(false);

    // Aplicar visibilidad real a todos los asientos
    this.sectionSeats._objects.forEach(seatElement => {
      if (!seatElement.numberLeft && !seatElement.numberRight && seatElement.row) {
        const visible = seatElement.isVisible !== false;
        seatElement.visible = visible;
        seatElement.selectable = visible;
        seatElement.evented = visible;
        if (!visible) {
          changeSeatColor(seatElement, this.colorDefaultVisibility);
        } else if (seatElement.colorSpecial) {
          // Restaurar color especial de butacas con nivel propio
          changeSeatColor(seatElement, seatElement.colorSpecial);
        }
      }
    });

    // Actualizar lista de ocultos
    this.invisibleSeats = this.sectionSeats._objects.filter(s => s.isVisible === false && !s.numberLeft && !s.numberRight);

    // Guardar en seatSections
    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        seatSections[this.sectionNumber].elements.forEach(element => {
          const seat = this.sectionSeats._objects.find(
            s => !s.numberLeft && !s.numberRight && +s.row === +element.row && +s.column === +element.column
          );
          if (seat) {
            element.isVisible = seat.isVisible;
            if (element.configuration) {
              element.configuration.isVisible = seat.isVisible;
            }
          }
        });
        this.generateMapService.setSeatSections(seatSections);
      } catch (error) {
        console.error('Error al guardar asientos ocultos:', error);
      }
    }

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  selectInvisibleSeats() {
    this.selectingInvisibleMode = true;
    this.setHiddenSectionMode.emit(true);

    // Mostrar todos los asientos para poder hacer clic en los ocultos
    this.sectionSeats._objects.forEach(seatElement => {
      if (!seatElement.numberLeft && !seatElement.numberRight && seatElement.row) {
        seatElement.visible = true;
        seatElement.selectable = true;
        seatElement.evented = true;
        const visibleColor = seatElement.colorSpecial || this.level.color;
        const color = seatElement.isVisible !== false ? visibleColor : this.colorDefaultVisibility;
        changeSeatColor(seatElement, color);
      }
    });
    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.canvas.renderAll();
  }

  toggleHiddenSeatsPanel() {
    this.activeHiddenSeats = !this.activeHiddenSeats;
    if (!this.activeHiddenSeats) {
      this.mostrarOcultos = false;
      this.sectionSeats._objects.forEach(seatElement => {
        if (!seatElement.numberLeft && !seatElement.numberRight && seatElement.row) {
          seatElement.visible = seatElement.isVisible !== false;
        }
      });
      this.sectionSeats.addWithUpdate();
      this.sectionElement.addWithUpdate();
      this.canvas.renderAll();
    }
  }

  changeMostrarOcultos() {
    this.sectionSeats._objects.forEach(seatElement => {
      if (!seatElement.numberLeft && !seatElement.numberRight && seatElement.row) {
        if (this.mostrarOcultos) {
          seatElement.visible = true;
          if (seatElement.isVisible === false) {
            seatElement.evented = true;
            seatElement.selectable = false;
            seatElement.hoverCursor = 'pointer';
          }
          const visibleColor = seatElement.colorSpecial || this.level?.color || this.colorDefaultSeat;
          const color = seatElement.isVisible !== false ? visibleColor : this.colorDefaultVisibility;
          changeSeatColor(seatElement, color);
        } else {
          const visible = seatElement.isVisible !== false;
          seatElement.visible = visible;
          seatElement.evented = visible;
          seatElement.selectable = visible;
          seatElement.hoverCursor = visible ? 'pointer' : 'default';
        }
      }
    });
    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.canvas.renderAll();
  }

  toggleSpecialSeatsPanel() {
    this.activeSpecialSeats = !this.activeSpecialSeats;
    if (!this.activeSpecialSeats && this.selectingSpecialMode) {
      this.cancelSpecialSeatsMode();
    }
  }

  activateSpecialSeatsMode() {
    if (!this.specialSeatLevel) return;
    this.selectingSpecialMode = true;
    this.setSpecialSeatMode.emit({ active: true, level: this.specialSeatLevel });
  }

  cancelSpecialSeatsMode() {
    if (this.selectingSpecialMode) {
      this.selectingSpecialMode = false;
      this.setSpecialSeatMode.emit({ active: false });
      // Restaurar colores de las butacas: section.color para las normales, special_color para las especiales
      const storedSections = this.generateMapService.getSeatSections();
      const sectionData = storedSections?.[this.sectionNumber];
      this.sectionSeats._objects.forEach((seatElement: any) => {
        if (!seatElement.eventSeat || seatElement.numberLeft || seatElement.numberRight) return;
        const el = sectionData?.elements?.find((e: any) => e.row === seatElement.row && e.column === seatElement.column);
        const color = el?.configuration?.special_color || sectionData?.section?.color || this.seatColor;
        changeSeatColor(seatElement, color);
      });
      this.sectionSeats.addWithUpdate();
      this.sectionElement.addWithUpdate();
      this.canvas.renderAll();
    }
  }

  cancelEdit(exit: boolean = false) {
    // Si estaba en modo selección de butacas especiales, limpiar
    if (this.selectingSpecialMode) {
      this.cancelSpecialSeatsMode();
      return;
    }
    // Si estaba en modo selección de ocultos, limpiar
    if (this.selectingInvisibleMode) {
      this.selectingInvisibleMode = false;
      this.setHiddenSectionMode.emit(false);
      // Restaurar visibilidad real
      this.sectionSeats._objects.forEach(seatElement => {
        if (!seatElement.numberLeft && !seatElement.numberRight && seatElement.row) {
          const visible = seatElement.isVisible !== false;
          seatElement.visible = visible;
          seatElement.selectable = visible;
          seatElement.evented = visible;
          if (visible && seatElement.colorSpecial) {
            changeSeatColor(seatElement, seatElement.colorSpecial);
          }
        }
      });
      this.sectionSeats.addWithUpdate();
      this.sectionElement.addWithUpdate();
      this.canvas.renderAll();
      return;
    }
    if (this.firstTime) {
      this.activedEditing = false;
    }
    this.updateCanvas.emit(exit);
  }

  cancelEditSeat() {
    this.openSeatEditing = false;
    this.seatsEditSelected = [];
    this.sitSelect = null;

    // this.updateCanvas.emit(false);
  }

  saveEditSeats(event: any) {
    if (!event) {
      this.sectionSeats._objects.forEach(seatElement => {
        if (seatElement.eventSeat) {
          seatElement.visible = seatElement.isVisible;
        }
      });
    }
    this.updateCanvas.emit();
  }

  addSeat(filas: any, columns: any) {
    const storedSections = this.generateMapService.getSeatSections();
    let seatSections = storedSections;
    let sectionElement = seatSections[this.sectionNumber];

    const { mainGroup, sectionObject } = this.generateMapService.addGroupSeats(filas, columns, this.sectionNumber, sectionElement);
    mainGroup.setControlVisible('mtr', false);
    this.generateMapService.setSeatSections(seatSections);
    // Actualizar la seccion en el localStorage

    return mainGroup;
  }

  createSeat(seatNumber: any, fill: boolean = true) {
    const circle = new fabric.Circle({
      radius: 50,
      fill: 'transparent',
      strokeWidth: 2,
      originX: 'center',
      originY: 'center',
    });
    var color = 'black';
    if (fill) {
      circle.fill = this.colorDefaultSeat;
      circle.stroke = '#4D4D4D';
      color = 'black';
    }

    var text = this.createTextComponent(seatNumber.toString(), 40, 0, color);

    var group = new fabric.Group([circle, text], {
      hasControls: false,
      radius: 50,
    });
    return group;
  }

  addText() {
    const text = new fabric.Textbox('Escribe un texto...', {
      width: 200,
      height: 100,
      fontSize: 24,
      // fontFamily: 'Satoshi-Regular',
      cursorColor: '#FF4D80',
      left: 50,
      top: 50,
      eventSeat: false
    });
    this.canvas.add(text);
  }

  createTextComponent(text: any, fontsize: number, top: number = 0, color: string = 'black') {
    let textComponent = new fabric.Text(text, {
      // fontFamily: 'Satoshi-Regular',
      fontSize: fontsize,
      fill: color,
      textAlign: 'center',
      originX: 'center',
      originY: 'center',
      eventSeat: false,
      top: top
    });
    return textComponent;
  }

  changeVisibilityRows(side: 'left' | 'right') {
    const legend = side === 'left' ? 'rowsLegendLeft' : 'rowsLegendRight';
    const value = side === 'left' ? this.legendLeft : this.legendRight;
    this.sectionElement.set(legend, value);
    this.sectionSeats._objects.forEach(seatElement => {
      if ((side === 'left' && seatElement.numberLeft) || (side === 'right' && seatElement.numberRight)) {
        seatElement.set('visible', value);
        seatElement.set('isVisible', value);
      }
    });

    const storedSections = this.generateMapService.getSeatSections();
    if (storedSections) {
      try {
        let seatSections = storedSections;
        seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.rowsLegendLeft = this.legendLeft;
        seatSections[this.sectionNumber].section.configuration.seatsGroupConfig.rowsLegendRight = this.legendRight;

        this.generateMapService.setSeatSections(seatSections);

      } catch (error) {
        // if (AppSettings.DEBUG) {
        console.error('Error al parsear seatSection desde localStorage:', error);
        // }
      }
    }

    this.sectionSeats.addWithUpdate();
    this.sectionElement.addWithUpdate();
    this.updateCanvas.emit();
  }

  // Guarda en la config de la sección qué parte de la posición se enseña al comprador.
  // No toca el lienzo: el plano del editor sigue mostrando fila y butaca siempre, esto
  // solo viaja hasta la entrada, el carrito y el escáner. Al publicar el mapa,
  // SpaceRepository vuelca estas dos claves a map_sections.show_row/show_seat_label.
  persistTicketLabelFlags() {
    const storedSections = this.generateMapService.getSeatSections();
    const groupConfig = storedSections?.[this.sectionNumber]?.section?.configuration?.seatsGroupConfig;
    if (!groupConfig) return;
    groupConfig.showRowOnTicket = this.showRowOnTicket;
    groupConfig.showSeatLabelOnTicket = this.showSeatLabelOnTicket;
    this.generateMapService.setSeatSections(storedSections);
  }

  editSeatNumber(seatElement: any) {
    seatElement.set('seat', +this.valueSeat);
    let elementText = seatElement._objects.find(value => value.type == 'text');
    elementText.set('text', this.valueSeat);
    return seatElement;
  }

  changeNumPar() {
    this.numeracionImpar = false;
    this.applySectionNumbering();
  }

  changeNumImpar() {
    this.numeracionPar = false;
    this.applySectionNumbering();
  }

  changeDirection() {
    this.applySectionNumbering();
  }

  persistSeatNumbers() {
    const storedSections = this.generateMapService.getSeatSections();
    if (!storedSections) return;
    try {
      const seatSections = storedSections;
      if (seatSections[this.sectionNumber]) {
        seatSections[this.sectionNumber].elements.forEach((element: any) => {
          const seat = this.sectionSeats._objects.find(
            (s: any) => s.eventSeat && +s.row === +element.row && +s.column === +element.column
          );
          if (seat) {
            element.seat = seat.seat;
          }
        });
        this.generateMapService.setSeatSections(seatSections);
      }
    } catch (error) {
      console.error('Error al persistir numeración de asientos:', error);
    }
  }

  getCountEdit() {
    const array = this.seatsEditSelected.filter(value => value != null);
    return array?.length;
  }

  applyChangesSeat() {
    this.sectionElement._objects.forEach((seatElement) => {
      if (seatElement.eventSeat) {
        seatElement.visible = seatElement.isVisible;
        changeSeatColor(seatElement, this.colorDefaultSeat);
      }
    });
    this.seatsEditSelected.forEach((element) => {
      element = null
    });
    this.editSeatParams.emit(false);
  }

}

function changeSeatColor(elementSeat, color) {
  let elementStroke = elementSeat._objects.find(value => value.type != 'text');
  elementStroke?.set('fill', color);
  let rgb = hexToRgb(color);
  let textColor = (rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114) > 186 ? '#000' : '#fff'
  let elementText = elementSeat._objects.find(value => value.type == 'text');
  elementText?.set('fill', textColor);
  return elementSeat;
}

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}